import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Loader } from '@grandvisionhq/common';
import { useIntl, useSelector, statusSuccess, statusFailed, statusLoading } from '@grandvisionhq/state';
import PrescriptionSummary$1 from './PrescriptionSummary.js';
import { getPrescription, getPrescriptionType } from '../../../../state/configurator/selectors.js';

const PrescriptionSummaryContainer = ()=>{
    const { getLabel  } = useIntl();
    const prescription = useSelector(getPrescription);
    const prescriptionType = useSelector(getPrescriptionType);
    const labels = React.useMemo(()=>{
        if (!statusSuccess(prescription)) {
            return {};
        }
        const { parameters  } = prescription.result;
        const paramLabels = parameters.reduce((acc, { name  })=>swcHelpers.objectSpread({}, acc, {
                [name]: getLabel(`products.glasses.prescription.${name}`)
            })
        , {});
        return swcHelpers.objectSpread({}, paramLabels, {
            rightEye: getLabel('products.glasses.rightEye'),
            leftEye: getLabel('products.glasses.leftEye'),
            prescriptionTitle: getLabel('products.glasses.configurator.footer.prescription.title'),
            existingCustomer: getLabel('products.glasses.configurator.footer.existingCustomer'),
            emailPrescription: getLabel('products.glasses.configurator.footer.emailPrescription')
        });
    }, [
        getLabel,
        prescription
    ]);
    if (statusFailed(prescription)) {
        return /*#__PURE__*/ React.createElement("p", null, getLabel('products.glasses.prescription.loadingFailed'));
    }
    if (statusLoading(prescription)) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    }
    if (!statusSuccess(prescription)) {
        return null;
    }
    const { right , left , parameters: parameters1 , uploadReferences  } = prescription.result;
    return /*#__PURE__*/ React.createElement(PrescriptionSummary$1, {
        prescriptionType: prescriptionType,
        parameters: parameters1,
        right: right,
        left: left,
        labels: labels,
        uploadReferences: uploadReferences
    });
};
var PrescriptionSummary = PrescriptionSummaryContainer;

export { PrescriptionSummary as default };
//# sourceMappingURL=PrescriptionSummaryContainer.js.map
